import { render, staticRenderFns } from "./RespostaRadioboxEscolha.vue?vue&type=template&id=6ad6654c"
import script from "./RespostaRadioboxEscolha.vue?vue&type=script&lang=js"
export * from "./RespostaRadioboxEscolha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports